
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.205 18.5h16.59c1.697 0 2.754-1.767 1.906-3.175l-8.295-13.77c-.848-1.407-2.964-1.407-3.812 0L.3 15.326C-.55 16.733.509 18.5 2.205 18.5zm8.295-7.409c-.606 0-1.102-.476-1.102-1.058V7.916c0-.582.496-1.058 1.102-1.058.606 0 1.102.476 1.102 1.058v2.117c0 .582-.496 1.059-1.102 1.059zm1.102 4.234H9.398v-2.117h2.204v2.117z","fill":"#fff"}})])
          )
        }
      }
    